/**
 * @license
 * Copyright 2024 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
import { isImperativeGraph, toDeclarativeGraph, } from "../../run/run-imperative-graph.js";
export { GraphDescriptorHandle };
class GraphDescriptorHandle {
    graphId;
    #graph;
    #imperativeMain;
    #url;
    constructor(graph, graphId) {
        this.graphId = graphId;
        if (isImperativeGraph(graph)) {
            const { main } = graph;
            graph = toDeclarativeGraph(graph);
            this.#imperativeMain = main;
        }
        this.#graph = graph;
        this.#url = maybeURL(graph.url);
    }
    main() {
        return this.#imperativeMain;
    }
    url() {
        return this.#url;
    }
    outerGraph() {
        return this.#graph;
    }
    graph() {
        return this.graphId ? this.#graph.graphs[this.graphId] : this.#graph;
    }
    static create(graph, graphId) {
        if (graphId && !graph.graphs?.[graphId]) {
            return {
                success: false,
                error: `Unable to create a valid GraphDEscriptorHandle: subgraph "${graphId}" is not in the graph.`,
            };
        }
        return { success: true, result: new GraphDescriptorHandle(graph, graphId) };
    }
}
function maybeURL(url) {
    url = url || "";
    try {
        return new URL(url);
    }
    catch {
        return undefined;
    }
}
//# sourceMappingURL=graph-descriptor-handle.js.map